import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { UpdateMeDTOSalutationEnum } from '../../api';

const SALUTATION_OPTIONS = [UpdateMeDTOSalutationEnum.Mr, UpdateMeDTOSalutationEnum.Ms, UpdateMeDTOSalutationEnum.Divers] as const;
// set only by the external sync - displayed if present, never user-selectable
const SYNCED_SALUTATION = UpdateMeDTOSalutationEnum.Company;

type Props<T extends FieldValues> = {
  name: Path<T>;
  id?: string;
  labelId?: string;
  control: Control<T>;
  getLabel: (value: string) => string;
  errorText?: React.ReactNode;
  emptyLabel: React.ReactNode;
  disabled?: boolean;
};

export function SalutationSelectControl<T extends FieldValues>({
  control,
  name,
  id,
  labelId,
  getLabel,
  errorText,
  emptyLabel,
  disabled,
}: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl fullWidth error={fieldState.invalid}>
          <Select
            {...field}
            value={field.value ?? ''}
            id={id}
            labelId={labelId}
            disabled={disabled}
            fullWidth
            data-testid="salutation-select"
            MenuProps={{ slotProps: { list: { disabledItemsFocusable: true } } }}
          >
            <MenuItem value="" data-testid="salutation-option-empty">
              {emptyLabel}
            </MenuItem>
            {SALUTATION_OPTIONS.map(option => (
              <MenuItem key={option} value={option} data-testid={`salutation-option-${option}`}>
                {getLabel(option)}
              </MenuItem>
            ))}
            {field.value === SYNCED_SALUTATION && (
              <MenuItem value={SYNCED_SALUTATION} disabled data-testid={`salutation-option-${SYNCED_SALUTATION}`}>
                {getLabel(SYNCED_SALUTATION)}
              </MenuItem>
            )}
          </Select>
          {fieldState.invalid && errorText && <FormHelperText>{errorText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
}
